var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / TW") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-TW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FE3030",
    mask: "url(#mask-2)",
    x: -1.33333333,
    y: -1.33333333,
    width: 30.6666667,
    height: 22.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#0909B6",
    mask: "url(#mask-2)",
    x: -1.33333333,
    y: -1.33333333,
    width: 16,
    height: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-27",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "7.33333333 7 6.05772189 8.41293178 6.15482203 6.51184464 4.25373489 6.60894477 5.66666667 5.33333333 4.25373489 4.05772189 6.15482203 4.15482203 6.05772189 2.25373489 7.33333333 3.66666667 8.60894477 2.25373489 8.51184464 4.15482203 10.4129318 4.05772189 9 5.33333333 10.4129318 6.60894477 8.51184464 6.51184464 8.60894477 8.41293178"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/TW.e2c169951e12e7299d93605131bf92ef.svg";
export { ForwardRef as ReactComponent };